import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';
import { Col } from 'antd';

export const NotesTextArea = styled(TextArea)`
  width: 280px;
  min-height: 50px;
!important;
  height: auto !important;
  max-height: 200px !important;
  color: #918faa !important;
  background-color: #f1f5f9 !important;
  border: 1px solid #918faa !important;
  resize: none !important;
  cursor: pointer !important;
`;

export const StyledHeaderRowCol = styled(Col)<{ paddingleft?: number }>`
  color: white;
  padding: 5px;
  font-weight: 700;
  font-size: 15px;
  padding-left: ${(p) => (p.paddingleft ? p.paddingleft : 0)}px;
`;

export const StyledCol = styled(Col)<{ color?: string }>`
  font-size: 16px;
  color: ${(p) => (p.color === 'primary' ? '#231f55' : p.color === 'secondary' ? '#8b97a8' : p.color)};
`;
